import React from 'react';
import classNames from 'classnames';
import { node, string } from 'prop-types';

import DashboardMobileNav from '../DashboardMobileNav/DashboardMobileNav';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';
import LinkedLogo from '../Logo/LinkedLogo';

import css from './DashboardLayout.module.css';

const DashboardLayout = ({
  children,
  topbar = null,
  className = null,
  mainContentClassName = null,
  headerClassName = null,
  pageContentClassName = null,
}) => {
  return (
    <div className={classNames(css.dashboardPage, className)}>
      <aside className={css.sideBar}>
        <LinkedLogo className={classNames(css.logoLink, css.logo)} layout="mobile" />
        <DashboardSidebar />
      </aside>

      <div className={classNames(css.mainContent, mainContentClassName)}>
        <header className={classNames(css.header, headerClassName)}>
          {topbar}
          <div className={css.mobileSidebarBar}>
            <DashboardMobileNav />
          </div>
        </header>
        <main id="main-content" className={classNames(css.pageContent, pageContentClassName)}>
          {children}
        </main>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: node.isRequired,
  topbar: node,
  className: string,
  mainContentClassName: string,
  headerClassName: string,
  pageContentClassName: string,
};

export default DashboardLayout;
